import React from 'react';
import { Link } from 'react-router-dom';

const Forbidden = () => (
  <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
    <h1 className="text-6xl font-bold text-gray-800">403</h1>
    <p className="text-lg text-gray-600">Access Forbidden. You do not have permission to view this page.</p>
    <Link
      to="/"
      className="mt-4 px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-600"
    >
      Go Back Home
    </Link>
  </div>
);

export default Forbidden;
